import { semantical } from 'src/theme/tokens/semantical';
import { convertHexColorToRgba } from 'src/utils/styles/color';

export const backDropTheme = {
  backgroundColor: convertHexColorToRgba(`${semantical.colors.background.neutral.stronger}`, 0.5),
  bluriness: semantical.colors.background.special.blur,
};
